<div class="auto-reframe-modal">
  <header class="auto-reframe-modal__header">
    <div class="auto-reframe-modal__header-titles">
      <h2 class="auto-reframe-modal__title">AI Reframing Workspace</h2>
      <p class="auto-reframe-modal__subtitle">
        Reframing for {{ aspectRatio }}
      </p>
    </div>
    <button
      type="button"
      class="auto-reframe-modal__btn auto-reframe-modal__btn--exit"
      (click)="exitReframe()"
    >
      &#10005; Exit Reframe
    </button>
  </header>

  <div class="auto-reframe-modal__main">
    <div class="auto-reframe-modal__canvases">
      <div class="auto-reframe-modal__source-col">
        <span class="auto-reframe-modal__section-label">Source content</span>
        <div class="auto-reframe-modal__source-wrap">
          <video
            #sourceVideo
            class="auto-reframe-modal__source-video"
            [class.auto-reframe-modal__source-video--hidden]="activeSourceIndexForDisplay !== -1"
            [src]="media.previewUrl"
            muted
            playsinline
            (loadedmetadata)="seekVideoToCurrent(); drawCanvases()"
            (loadeddata)="drawCanvases()"
            (canplay)="drawCanvases()"
          ></video>
          <ng-container *ngIf="appendedMamSegments?.length">
            <video
              #appendedVideo
              *ngFor="let seg of appendedMamSegments; let i = index"
              [src]="seg.previewUrl"
              class="auto-reframe-modal__source-video"
              [class.auto-reframe-modal__source-video--hidden]="activeSourceIndexForDisplay !== i"
              muted
              playsinline
              preload="auto"
              (loadeddata)="drawCanvases()"
              (canplay)="drawCanvases()"
            ></video>
          </ng-container>
          <ng-container *ngIf="orderedEditMamClips.length">
            <video
              #editMamVideo
              *ngFor="let clip of orderedEditMamClips; let i = index"
              [src]="clip.previewUrl"
              class="auto-reframe-modal__source-video"
              [class.auto-reframe-modal__source-video--hidden]="activeSourceIndexForDisplay !== (appendedMamSegments?.length ?? 0) + i"
              muted
              playsinline
              preload="auto"
              (loadeddata)="drawCanvases()"
              (canplay)="drawCanvases()"
            ></video>
          </ng-container>
          <canvas
            #sourceOverlay
            class="auto-reframe-modal__source-overlay"
            [class.auto-reframe-modal__source-overlay--resizing]="
              isResizingFillCrop
            "
            [class.auto-reframe-modal__source-overlay--readonly]="
              adjustmentMode === 'ai'
            "
            [width]="sourceOverlayWidth"
            [height]="sourceOverlayHeight"
            (mousedown)="onOverlayMouseDown($event)"
            (mousemove)="onOverlayMouseMove($event)"
            (mouseup)="onOverlayMouseUp()"
            (mouseleave)="onOverlayMouseUp()"
          ></canvas>
        </div>
        <p class="auto-reframe-modal__source-hint">
          Drag blue zone to move &bull; Use bottom-right handle to resize
        </p>
      </div>
      <div class="auto-reframe-modal__output-col">
        <span class="auto-reframe-modal__section-label">Live output</span>
        <div
          class="auto-reframe-modal__output-wrap"
          [style.aspect-ratio]="aspectRatioCss"
        >
          <canvas
            #outputCanvas
            class="auto-reframe-modal__output-canvas"
            [width]="outputCanvasWidth"
            [height]="outputCanvasHeight"
          ></canvas>
        </div>
      </div>
    </div>

    <aside class="auto-reframe-modal__sidebar">
      <section class="auto-reframe-modal__panel">
        <div class="auto-reframe-modal__adjustment-mode">
          <h3 class="auto-reframe-modal__panel-title">ADJUSTMENT MODE</h3>
          <span
            class="auto-reframe-modal__ai-badge"
            *ngIf="adjustmentMode === 'ai'"
            >&#9733; AI APPLIED</span
          >
        </div>
        <div class="auto-reframe-modal__field" *ngIf="showAdjustmentOptionsField">
          <div class="auto-reframe-modal__adjustment-options">
            <label
              class="auto-reframe-modal__adjustment-option"
              [class.auto-reframe-modal__adjustment-option--active]="
                adjustmentMode === 'ai'
              "
            >
              <input
                type="radio"
                name="adjustmentMode"
                value="ai"
                [checked]="adjustmentMode === 'ai'"
                (change)="setAdjustmentMode('ai')"
              />
              <span class="auto-reframe-modal__adjustment-option-title"
                >AI Subject Tracking</span
              >
              <span class="auto-reframe-modal__adjustment-option-desc"
                >Follows main characters</span
              >
            </label>
            <label
              class="auto-reframe-modal__adjustment-option"
              [class.auto-reframe-modal__adjustment-option--active]="
                adjustmentMode === 'manual'
              "
            >
              <input
                type="radio"
                name="adjustmentMode"
                value="manual"
                [checked]="adjustmentMode === 'manual'"
                (change)="setAdjustmentMode('manual')"
              />
              <span class="auto-reframe-modal__adjustment-option-title"
                >Manual Adjustment</span
              >
              <span class="auto-reframe-modal__adjustment-option-desc"
                >Custom positioning</span
              >
            </label>
          </div>
        </div>

        <ng-container *ngIf="adjustmentMode === 'manual'">
          <h3 class="auto-reframe-modal__panel-title">Layout</h3>
          <div class="auto-reframe-modal__field">
            <div class="auto-reframe-modal__radios">
              <label
                *ngFor="let opt of layoutModes"
                class="auto-reframe-modal__radio"
              >
                <input
                  type="radio"
                  name="layout"
                  [value]="opt.value"
                  [checked]="currentReframe.layout === opt.value"
                  (change)="setLayout(opt.value)"
                />
                <span>{{ opt.label }}</span>
              </label>
            </div>
          </div>
          <div class="auto-reframe-modal__field" *ngIf="showBackgroundStyle">
            <span class="auto-reframe-modal__label">Background style</span>
            <div class="auto-reframe-modal__btn-group">
              <button
                *ngFor="let opt of backgroundStyles"
                type="button"
                class="auto-reframe-modal__btn auto-reframe-modal__btn--chip"
                [class.auto-reframe-modal__btn--chip-active]="
                  currentReframe.backgroundStyle === opt.value
                "
                (click)="setBackgroundStyle(opt.value)"
              >
                {{ opt.label }}
              </button>
            </div>
          </div>
          <div
            class="auto-reframe-modal__field"
            *ngIf="currentReframe.layout === 'split50'"
          >
            <button
              type="button"
              class="auto-reframe-modal__btn auto-reframe-modal__btn--secondary"
              (click)="swapTopBottom()"
            >
              Swap Top/Bottom
            </button>
          </div>
          <div
            class="auto-reframe-modal__field"
            *ngIf="
              activeKeyframeIndex != null && activeClipKeyframes.length > 1
            "
          >
            <button
              type="button"
              class="auto-reframe-modal__btn auto-reframe-modal__btn--secondary"
              (click)="deleteActiveKeyframe()"
            >
              Delete keyframe
            </button>
          </div>
        </ng-container>
        <div class="auto-reframe-modal__actions">
          <button
            type="button"
            class="auto-reframe-modal__btn auto-reframe-modal__btn--secondary auto-reframe-modal__btn--reset"
            *ngIf="adjustmentMode === 'manual'"
            (click)="resetToAiSuggestion()"
          >
            &#8635; Reset to AI Suggestion
          </button>
          <button
            type="button"
            class="auto-reframe-modal__btn auto-reframe-modal__btn--secondary"
            (click)="applyToAllClips()"
            *ngIf="adjustmentMode === 'manual'"
          >
            Apply manual to all clips
          </button>
          <button
            type="button"
            class="auto-reframe-modal__btn auto-reframe-modal__btn--primary"
            (click)="confirmAndSave()"
          >
            Confirm & Save Reframes
          </button>
        </div>
      </section>
    </aside>
  </div>

  <div class="auto-reframe-modal__bottom">
    <div class="auto-reframe-modal__clip-strip-header">
      <span class="auto-reframe-modal__section-label">Clips</span>
      <span class="auto-reframe-modal__clip-strip-status"
        >AI reframed {{ aiReframedCount }}/{{ clips.length }} &#10003;</span
      >
    </div>
    <div class="auto-reframe-modal__clip-strip">
      <button
        *ngFor="let clip of clips; let i = index"
        type="button"
        class="auto-reframe-modal__clip-thumb"
        [class.auto-reframe-modal__clip-thumb--active]="i === activeClipIndex"
        [class.auto-reframe-modal__clip-thumb--with-image]="
          clip.thumbnailFirstFrameUrl
        "
        (click)="onClipSelect(i)"
        [attr.aria-label]="clip.label || 'Clip ' + (i + 1)"
      >
        <span
          class="auto-reframe-modal__clip-thumb-badge auto-reframe-modal__clip-thumb-badge--ai"
          *ngIf="!isClipManual(clip.id)"
          >AI</span
        >
        <span
          class="auto-reframe-modal__clip-thumb-badge auto-reframe-modal__clip-thumb-badge--manual"
          *ngIf="isClipManual(clip.id)"
          >Manual</span
        >
        <img
          *ngIf="clip.thumbnailFirstFrameUrl"
          class="auto-reframe-modal__clip-thumb-img"
          [src]="clip.thumbnailFirstFrameUrl"
          [alt]="clip.label || 'Clip ' + (i + 1)"
        />
        <span
          *ngIf="!clip.thumbnailFirstFrameUrl"
          class="auto-reframe-modal__clip-thumb-fallback"
          >{{ clip.label || "Clip " + (i + 1) }}</span
        >
        <span class="auto-reframe-modal__clip-thumb-label"
          >Clip {{ i + 1 }}</span
        >
        <span class="auto-reframe-modal__clip-thumb-duration"
          >{{ (clip.outMs - clip.inMs) / 1000 | number: "1.0-0" }}s</span
        >
      </button>
    </div>
    <div class="auto-reframe-modal__timeline-row">
      <button
        type="button"
        class="auto-reframe-modal__play-btn"
        (click)="togglePlay()"
        [attr.aria-label]="playing ? 'Pause' : 'Play'"
      >
        <span
          class="auto-reframe-modal__play-icon"
          [class.auto-reframe-modal__play-icon--playing]="playing"
        ></span>
      </button>
      <span class="auto-reframe-modal__time-current">{{
        currentTimeFormatted
      }}</span>
      <div
        class="auto-reframe-modal__timeline"
        (click)="onTimelineClick($event)"
      >
        <div
          class="auto-reframe-modal__timeline-fill"
          [style.width.%]="
            clipDurationMs ? (100 * currentTimeMs) / clipDurationMs : 0
          "
        ></div>
        <button
          *ngFor="let kf of activeClipKeyframes; let i = index"
          type="button"
          class="auto-reframe-modal__timeline-keyframe"
          [style.left.%]="
            clipDurationMs ? (100 * kf.timeMs) / clipDurationMs : 0
          "
          [class.auto-reframe-modal__timeline-keyframe--selected]="
            activeKeyframeIndex === i
          "
          (click)="selectKeyframe(i); $event.stopPropagation()"
          [attr.aria-label]="'Go to keyframe at ' + kf.timeMs / 1000 + 's'"
          [title]="'Go to keyframe at ' + kf.timeMs / 1000 + 's'"
        ></button>
        <div
          class="auto-reframe-modal__timeline-playhead"
          [style.left.%]="
            clipDurationMs ? (100 * currentTimeMs) / clipDurationMs : 0
          "
          role="presentation"
        ></div>
      </div>
      <div class="auto-reframe-modal__timeline-meta">
        <span class="auto-reframe-modal__clip-duration-label"
          >Clip duration: {{ clipDurationMs / 1000 | number: "1.0-0" }}s</span
        >
        <span class="auto-reframe-modal__time-total">{{
          totalTimeFormatted
        }}</span>
      </div>
    </div>
  </div>
</div>
